import angular from 'angular';

// ES6 modules are strict by default
const formsServices = angular.module('applicationModule.formsServices', []);

formsServices.factory('Forms', ['FormsAPI', function (FormsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return FormsAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (id, appId) {
            return FormsAPI.get(id, appId);
        },
        save: function (form, editMode) {
            if (editMode) {
                return FormsAPI.edit(form);
            } else {
                return FormsAPI.create(form);
            }
        },
        remove: function (id, appId) {
            return FormsAPI.remove(id, appId);
        },
        copy: function (formId) {
            return FormsAPI.copy(formId);
        },
        generateCSV: function (appId, formId) {
            return FormsAPI.generateCSV(appId, formId);
        }
    };
}]);

formsServices.service('FormsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/form/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.create = function (form) {
        return $http.post(API_URL + 'create', form);
    };
    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (form) {
        return $http.put(API_URL + 'update/' + form.id, form);
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.copy = function (formId) {
        return $http.get(API_URL + 'copy/' + formId);
    };

    this.generateCSV = function (appId, formId) {
        return $http.post(API_URL + 'report/', {application_id: appId, form_id: formId});
    };

}]);

formsServices.factory('FormElements', ['FormElementsAPI', function (FormElementsAPI) {
    'use strict';

    return {
        getList: function (appId, formId, params) {
            return FormElementsAPI.getList(appId, formId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (id, appId) {
            return FormElementsAPI.get(id, appId);
        },
        save: function (element, editMode) {
            if (editMode) {
                return FormElementsAPI.edit(element);
            } else {
                return FormElementsAPI.create(element);
            }
        },
        remove: function (id, appId) {
            return FormElementsAPI.remove(id, appId);
        },
        changeOrder: function (data) {
            return FormElementsAPI.changeOrder(data);
        }
    };
}]);

formsServices.service('FormElementsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/form-element/';

    this.getList = function (appId, formId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                form_id: formId
            })
        });
    };

    this.create = function (element) {
        return $http.post(API_URL + 'create', element);
    };
    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (element) {
        return $http.put(API_URL + 'update/' + element.id, element);
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.changeOrder = function (data) {
        const url = API_URL + 'change-order/';

        return $http.post(url, data);
    };

}]);

export default formsServices;
